const inititalState = { assetItem: 0 };
const addAssetReducer = (state = inititalState, action) => {
  switch (action.type) {
    case "CHANGEASSET": {
      return { ...state, assetItem: action.payload };
    }
  }
  return state;
};
export default addAssetReducer;